export default "__VITE_ASSET__SdYPPAOO__"